import { useNavigation } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import Button from '~/components/Button';
import Card from '~/components/Card';
import Form from '~/components/Form';
import Icon from '~/components/Icon';
import LinkButton from '~/components/LinkButton';
import Submit from '~/components/Submit';
import { Tooltip, TooltipContent, TooltipTrigger } from '~/components/Tooltip';
import { useIsLoading } from '~/utils/routing';
import ProductExchange from './product-exchange/ProductExchange';
import { FormKey, useLoaderData } from './resolution';

// TODO: SHOP NOW refine tooltip language
function ShopNowTooltip() {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="text">
          <Icon icon="InfoCircleSolid" className="size-4 text-primary" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        Your return credit will be saved, and you will be redirected to Shop Now
        after you have finished making your selections.
      </TooltipContent>
    </Tooltip>
  );
}

function Credit({ className }: { className?: string }) {
  const navigation = useNavigation();
  const isLoading = useIsLoading();
  const {
    canExchange,
    creditResolutionMethod,
    creditDetailText,
    creditHeadlineText,
    offerShopNow,
  } = useLoaderData();

  // TODO: SHOP NOW wordsmith this for shop now
  return (
    <Card
      headline={canExchange ? creditHeadlineText : 'Next Steps'}
      className={className}
    >
      <p className="text-gray-500">{creditDetailText}</p>
      <Form name="credit" className="flex flex-col gap-4" aria-label="credit">
        {offerShopNow && (
          <div className="flex items-center gap-2">
            <Submit
              name={FormKey.shopNow}
              value="true"
              loading={isLoading && !navigation.formData?.has(FormKey.variant)}
            >
              Shop Now
            </Submit>
            <ShopNowTooltip />
          </div>
        )}
        <input
          type="hidden"
          hidden
          data-testid="creditResolution"
          name={FormKey.resolution}
          value={creditResolutionMethod}
        />
        <Submit
          variant={offerShopNow ? 'text' : 'outlined'}
          className={twMerge(!!offerShopNow && 'md:w-full')}
          loading={isLoading && !navigation.formData?.has(FormKey.variant)}
        >
          Continue with return
        </Submit>
      </Form>
    </Card>
  );
}

function EscapeHatch() {
  const { canExchange, orderId, store } = useLoaderData();

  // ? in the case that a customer doesn't want a variant exchange, we show the escape hatch indicating to reach out to the merchant
  // ? isExchangeOnly should allow variant exchange OR store credit
  const message =
    canExchange ?
      "If an exchange doesn't fit your needs, please reach out to our team."
    : "It looks like we can't handle this return automatically, please reach out to our team.";

  return (
    <Card headline="Need help?">
      <p>{message}</p>
      <LinkButton
        className="mt-6 w-full md:w-1/2"
        variant="outlined"
        to={`/${store}/order/${orderId}`}
      >
        Back to Order
      </LinkButton>
    </Card>
  );
}

export default function ResolutionPage() {
  // shouldPrioritizeCredit is a boolean that determines if the refund should be prioritized over the exchange (what order the cards display)
  const { canExchange, canCredit, shouldPrioritizeCredit } = useLoaderData();

  return (
    <div className="flex flex-col gap-4">
      {canExchange && <ProductExchange />}
      {/* prioritize exchange card */}
      {/* // TODO hide credit within a product variant selection if there are exchange products */}
      {canCredit && (
        <Credit className={twMerge(shouldPrioritizeCredit && 'order-first')} />
      )}
      {!canCredit && <EscapeHatch />}
    </div>
  );
}
